import React from 'react';
import './_button.scss';
import styled from "styled-components";
import Icon from "../icon/Icon";
import { BaseButton, ButtonSize, NewButtonProps } from "./ButtonStyling";
import Colours from "../Colours";
import { useTranslation } from "react-i18next";

export function SecondaryButton(props: NewButtonProps) {
  let buttonAttributes = {}
  const {t} = useTranslation();
  if (!!props.dataTest) {
    // @ts-ignore
    buttonAttributes['data-test'] = props.dataTest;
  }
  return (
    <SecondaryButtonWrapper {...buttonAttributes} fullWidth={!!props.fullWidth} size={props.size || ButtonSize.Medium}
                            disabled={!!props.disabled} className={props.className ?? ''}
                            type={props.buttonType ?? 'button'} style={props?.style ?? {}}
                            onClick={(e: any) => props.click(e)}>
      {props.icon && <Icon style={{marginRight: 8}} icon={props.icon ?? ''}/>}
      {props.text && <span>{t(props.text)}</span>}
    </SecondaryButtonWrapper>
  );
}

const SecondaryButtonWrapper = styled(BaseButton)<any>`
  background-color: white;
  color: ${props => !!props.disabled ? Colours.mildGrey : Colours.darkGrey};

  border: solid 2px ${Colours.black};
  border-color: ${props => !!props.disabled ? Colours.veryLightGrey : Colours.mildGrey};
  
  &:hover {
    background-color: ${props => !!props.disabled ? Colours.veryLightGrey : Colours.white};
  }
`
